import { useState } from 'react';
import { Outlet, useMatch } from 'react-router-dom';
import { ChevronDown, Database, Plus, Search, Sigma } from 'lucide-react';
import { RenderIf } from '@/components/RenderIf';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import type { MetricsOutletContext, MetricsProps } from './types';
import StatusFilter from './StatusFilter';
import {
    ContentContainer,
    HeaderRight,
    MetricsContainer,
    MetricsContent,
    MetricsHeader,
    SearchContainer,
    SearchIcon,
} from './styled';

function Metrics(_props: MetricsProps) {
    const [shouldOpenCreateModal, setShouldOpenCreateModal] = useState(false);
    const [shouldOpenDerivedMetricSheet, setShouldOpenDerivedMetricSheet] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const isOnListPage = useMatch('/agents/:agentId/metrics');

    const outletContext: MetricsOutletContext = {
        shouldOpenCreateModal,
        setShouldOpenCreateModal,
        shouldOpenDerivedMetricSheet,
        setShouldOpenDerivedMetricSheet,
        searchQuery,
        setSearchQuery,
    };

    return (
        <MetricsContainer>
            <MetricsContent>
                <RenderIf isTrue={!!isOnListPage}>
                    <MetricsHeader>
                        <HeaderRight>
                            <SearchContainer>
                                <SearchIcon>
                                    <Search size={18} />
                                </SearchIcon>
                                <Input
                                    type="text"
                                    placeholder="Search metrics..."
                                    value={searchQuery}
                                    onChange={event => setSearchQuery(event.target.value)}
                                />
                            </SearchContainer>
                            <StatusFilter />
                            <DropdownMenu>
                                <DropdownMenuTrigger asChild>
                                    <Button>
                                        <Plus className="mr-2 h-4 w-4" />
                                        New metric
                                        <ChevronDown className="ml-2 h-4 w-4" />
                                    </Button>
                                </DropdownMenuTrigger>
                                <DropdownMenuContent align="end" className="w-52">
                                    <DropdownMenuItem
                                        onSelect={() => setShouldOpenCreateModal(true)}
                                    >
                                        <Database />
                                        New stored metric
                                    </DropdownMenuItem>
                                    <DropdownMenuItem
                                        onSelect={() => setShouldOpenDerivedMetricSheet(true)}
                                    >
                                        <Sigma />
                                        New derived metric
                                    </DropdownMenuItem>
                                </DropdownMenuContent>
                            </DropdownMenu>
                        </HeaderRight>
                    </MetricsHeader>
                </RenderIf>
                <ContentContainer>
                    <Outlet context={outletContext} />
                </ContentContainer>
            </MetricsContent>
        </MetricsContainer>
    );
}

export default Metrics;
